import { Block } from 'baseui/block';
import { ISP_Cabinet } from './types'
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import { ValuePanelIcon as TemperaturPanel } from '../../Devices/SensorAnalog'
import { SmallPanel as AckPanel } from '../../Devices/Acknowledge'
import { LoadingView } from "../../../components";
import { CabinetIcon } from './CabinetIcon';
import { useGetObjectsChildren } from '../../../hooks/useGetObjectsChildren';
import { themedUseStyletron } from '../../../theme/customTheme';


export function OverviewPanel(props: ISP_Cabinet) {
    const [css,theme] = themedUseStyletron();
    
    const { children: childElement, isLoading, isSuccess, error } = useGetObjectsChildren(props.resourceGroupId,props.id)
    const temperature1 = childElement?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.TemperatureSensor");
    const ack = childElement?.find((v: any) => v.schema === "AutomationApps.Devices.Commons.Acknowledge");

    return (
        <OverviewPanelWrapper height={theme.appSizes.smallAppHeight}  {...props} includeAlarmsFromChildren={true} icon={<CabinetIcon width='100%' height='100%' color={theme.colors.backgroundPrimary}></CabinetIcon>}>
            <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
                <Block display='flex' flexDirection='column' alignItems='center' justifyContent='center' gridGap='25px'>
                    <Block display='flex' flexDirection='row' alignItems='center' justifyContent='center' gridGap='20px'>
                        {temperature1 &&
                            <TemperaturPanel {...temperature1}></TemperaturPanel>

                        }
                        {ack &&
                            <AckPanel {...ack}></AckPanel>
                        }
                    </Block>
                </Block>
            </LoadingView>
        </OverviewPanelWrapper>
    );
}